import { render, staticRenderFns } from "./AxInput.vue?vue&type=template&id=2d2fa936&scoped=true"
import script from "./AxInput.vue?vue&type=script&lang=ts"
export * from "./AxInput.vue?vue&type=script&lang=ts"
import style0 from "./AxInput.vue?vue&type=style&index=0&id=2d2fa936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2fa936",
  null
  
)

export default component.exports